<main class="main-content">
  <div class="container">
    <h1 class="page-title">Available Scholarships</h1>

    @if (state$ | async; as state) {
      @if (!state.isLoading && !state.error) {
        <div class="info-message">
          <i class="fas fa-info-circle"></i>
          The majority of scholarships are for postgraduate (masters, doctoral and postdoctoral) studies,
          while a small number of undergraduate (bachelor's degree) scholarships are available. Most of the
          scholarships advertised here are not managed by the DHET, and further information is only available
          from the agency or government concerned. Each offer has its own entry requirements and eligibility
          criteria. Please read through the information carefully and ensure that you meet all the minimum
          criteria and adhere to the submission deadlines.
          <strong>Please note that the information available on this website is provided as a guideline only.
            Information provided by the scholarship granting agency supersedes any information provided
          here.</strong>
        </div>
      }
      <!-- Loading State -->
      @if (state.isLoading) {
        <div class="loading-state">
          <i class="fas fa-spinner fa-spin"></i> Loading scholarships...
        </div>
      }
      <!-- Error State -->
      @if (state.error) {
        <div class="error-state">
          <i class="fas fa-exclamation-triangle"></i> {{ state.error }}
        </div>
      }
      <!-- Scholarships by Category -->
      @if (!state.isLoading && !state.error) {
        @if (state.scholarships.length > 0) {
          @for (category of categories; track trackByCategory($index, category)) {
            <div class="scholarship-category">
              <h2 class="category-title">{{ category.name }}</h2>
              @if (state.filteredScholarships[category.id].length > 0) {
                <div class="scholarship-grid">
                  @for (scholarship of state.filteredScholarships[category.id]; track trackByScholarship($index, scholarship)) {
                    <a
                      [routerLink]="['/scholarships', scholarship.id]" class="scholarship-card">
                      <div class="card-image">
                        <img [src]="getImageUrl(scholarship)" [alt]="scholarship.title"
                          loading="lazy">
                        <div class="card-overlay">
                          <span class="country-badge">
                          {{ scholarship.scholarshipTemplate.country.name }}</span>
                        </div>
                      </div>
                      <div class="card-content">
                        <h3 class="card-title">{{ scholarship.title }}</h3>
                        <div class="card-meta">
                          <div class="meta-item">
                            <i class="fas fa-building"></i>
                            <span>{{ scholarship.provider.name }}</span>
                          </div>
                          <div class="meta-item">
                            <i class="fas fa-level-up-alt"></i>
                            <span>{{ scholarship.category.name }}</span>
                          </div>
                        </div>
                        <p class="card-description">{{ scholarship.description }}</p>
                        <div class="card-footer">
                          <span class="deadline">
                            <i class="fas fa-calendar-alt"></i> Deadline: <strong>{{
                          scholarship.deadline | date:'EEEE, d MMMM yyyy' }}</strong>
                        </span>
                        <button class="btn-view">
                          View Details <i class="fas fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </a>
                }
              </div>
            }
          </div>
        }
      } @else {
        <div class="no-scholarships">
          No scholarships available at the moment. Please check again later.
        </div>
      }
    }
    <!-- Subscription Box -->
    <div class="subscription-box">
      <h3>Join our subscription list</h3>
      <p>Get regular updates about scholarship opportunities currently available for South African
      students to undertake university study and skills development in other countries.</p>
      <div class="subscription-form">
        <input type="email" placeholder="Enter your email address" #emailInput>
        <button class="btn-subscribe" (click)="subscribe(emailInput.value)">Subscribe</button>
      </div>
    </div>
  }
</div>
</main>